import React,{Components} from 'react';
import {Card, Button, CardTitle, CardDeck,CardText, CardHeader,CardBody ,Row, Col, CardSubtitle } from 'reactstrap';
import Eyes from '../../imgs/demoncollect.png';
import Soul from '../../imgs/smlsoul.png';
import Demon from '../../imgs/dlogo2.png';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

const { BN, Long, bytes, units } = require('@zilliqa-js/util');
const { Zilliqa } = require('@zilliqa-js/zilliqa');
const {toBech32Address,getAddressFromPrivateKey} = require('@zilliqa-js/crypto');
const { Transaction } = require('@zilliqa-js/account');

//Testnet and Mainnet
const zilliqa = new Zilliqa('https://dev-api.zilliqa.com');
//const zilliqa = new Zilliqa('https://api.zilliqa.com');

const chainIdDev = 333; // chainId of the developer testnet
const chainId = 1

const msgVersion = 1; // current msgVersion
const VERSION = bytes.pack(chainId, msgVersion);

const zilpay = window.zilPay;
//SwalAlerts
const MySwal = withReactContent(Swal);

//Soulz Testnet
const soulzBech32='zil15kx9ewftasepefd85kypqz399cdvec6fg4k5jw';
const soulzBase16='0xa58c5cb92bec321ca5a7a588100a252e1acce349';

//KrazySwap mainnet
//const contractSwapBech32='zil1u9ffr40c4uckcjvmfcth6n3g277fzht7x3z22z';
//const contractSwapBase16='0xe15291d5f8af316c499b4e177d4e2857bc915d7e';

//testnet
//const contractSwapBech32='zil1frs58zcfzvmakf9qd5g860w2wr25xz8h3lnk7c';
//const contractSwapBase16='0x48e1438b091337db24a06d107d3dca70d54308f7';


    //Kkz mainnet
const contractKkzBech32 = 'zil1p2cp77kz06wlxeyha4psawencm5gx8ttcwsxdn';
const contractKkzBase16 = '0x0ab01f7ac27e9df36497ed430ebb33c6e8831d6b'; 

//kkz testnet
//const contractKkzBech32 = 'zil1r463tdw3ewaryqxsr3eymj5g7796s4vxhf70a5';
//const contractKkzBase16 = '0x1d7515b5d1cbbA3200d01C724dca88f78BA85586';

export default class Farm extends React.Component{
    constructor(props){
        super(props)
        this.state={
          zilDeposit:0,//for soul reaping
          kkzDeposit:0,//for soul reaping
          demonZilDeposit:0,//for soul reaping
          kkzContractState:'',
          soulzContractState:'',
          isStakingKkz:false,
          isStakingZil:false,
          collectedSoulz:0,
          blockNumber:0,
          userAddress:'',
          
          
        }

        this.handleKkzDepositChange=this.handleKkzDepositChange.bind(this);
        this.handleSubmitKkzDeposit=this.handleSubmitKkzDeposit.bind(this);
        this.handleSubmitZilDeposit=this.handleSubmitZilDeposit.bind(this);
        this.handleZilDepositChange=this.handleZilDepositChange.bind(this);
        this.handeleDemonZilChange=this.handeleDemonZilChange.bind(this);
        this.handleSubmitDemonZilDeposit=this.handleSubmitDemonZilDeposit.bind(this);
        this.transferKkzFrom=this.transferKkzFrom.bind(this);
        this.stakeWithZil=this.stakeWithZil.bind(this);
        this.stakeWithKkz=this.stakeWithKkz.bind(this);
        this.claimBack=this.claimBack.bind(this);
        this.handleChangeClaim=this.handleChangeClaim.bind(this);
        this.handleSubmitClaim=this.handleSubmitClaim.bind(this);

    }

    componentDidMount(){
      this.getBlockchainStats();
      this.fetchUserAccount();
    }

    handleChangeClaim(event){
      this.setState({
        claimValue:event.target.value
      })
    }
  handleSubmitClaim(event){
    event.preventDefault();
  console.log("Clickeed....");
  this.claimBack()
  }

    handeleDemonZilChange(event){
      this.setState({
        demonZilDeposit:event.target.value
      });
    }

    handleSubmitDemonZilDeposit(event){
      event.preventDefault();

    }

    handleZilDepositChange(event) {
      this.setState({ zilDeposit: event.target.value });
    }
  
    handleSubmitZilDeposit(event) {
      event.preventDefault();
      console.log(this.state.zilDeposit)
      if (this.state.zilDeposit != 0) {

        this.stakeWithZil();
  
      } else {
  
        MySwal.fire({
          title: 'Error',
          text: 'You need to enter more than 0',
          icon: 'error'
        });
      }
    }

    handleKkzDepositChange(event) {
      this.setState({ kkzDeposit: event.target.value });
    }
  
    handleSubmitKkzDeposit(event) {
      event.preventDefault();

      if(this.state.kkzDeposit === 0){
        MySwal.fire({
          title:'You need more than 0 to Reap',
          icon:'error'
        });
      }else{
        this.stakeWithKkz();
      }

    }

    async fetchUserAccount() {   
      const userAddress =await zilpay.wallet.defaultAccount;
      const userAddressBase16=await userAddress.base16;
      const userAddressBech32 = userAddress.bech32;
      const isValidAddress =await window.zilPay.crypto.isValidChecksumAddress(userAddressBase16);
    
      this.setState({
        userAddress: userAddressBech32
      })
console.log(this.state.userAddress)
    }

    async transferKkzFrom(){
      
      const deployedContract=await zilpay.contracts.at('0x0ab01f7ac27e9df36497ed430ebb33c6e8831d6b');
      const sendAmt=this.state.kkzDeposit.toString()
      const newV=toString(sendAmt)
      const recipientAddress='0xA9d7d94a22aB16f5414BdfDAc4A563a7CdbD6283'

     const tx = deployedContract.call(
        'TransferFrom',[
        {
        tag:'TansferFrom',
        version:VERSION,
        vname: 'to',
        type: 'ByStr20',
        value: recipientAddress,
        toAddr:'0x9dbfbda58865bf1ecb5b60def4c638994a8cb4d6',
        amount:units.toQa(sendAmt,units.Units.Zil),
        gasPrice:units.toQa("20000",units.Units.Li),
        gasLimit:Long.fromNumber(1000),
      }],)
     // tx=await zilpay.blockchain.createTransaction(tx);
      console.log(tx.id);//start staking if success 
      
    }

    async stakeWithKkz(){
    
      try {
        const recipientAddress='0xA9d7d94a22aB16f5414BdfDAc4A563a7CdbD6283'
        const deployedContract=await zilpay.contracts.at('0x0ab01f7ac27e9df36497ed430ebb33c6e8831d6b');
        const sendAmt=this.state.kkzDeposit.toString();
        console.log(sendAmt)
        const newV=toString(sendAmt);
        console.log(newV)
          const callTx = await deployedContract.call(
              'Transfer',
              [
                  {
                      vname: 'to',
                      type: 'ByStr20',
                      value: recipientAddress,
                  },
                  {
                      vname: 'amount',
                      type: 'Uint128',
                      value: sendAmt,
                  }
              ],
              {
                  // amount, gasPrice and gasLimit must be explicitly provided
                  version: VERSION,
                  amount: new BN(0),
                  gasPrice:units.toQa("20000",units.Units.Li),
                  gasLimit:Long.fromNumber(1000),
              }
          );
      
      } catch (err) {
          console.log(err);
      }
    }
  
async stakeWithZil(){
  const deployedContract=await zilpay.contracts.at('0x97f4b7D65F48D830cb6bB8BECf2e1eC5Be2479d9');
  const sendAmt=this.state.zilDeposit.toString();
  console.log(sendAmt)
  const newV=toString(sendAmt);
  console.log(newV)
  const tx = deployedContract.call(
    'Reap',[],
    {
    tag:'Reap',
    version:VERSION,
    toAddr:'0x97f4b7D65F48D830cb6bB8BECf2e1eC5Be2479d9',
    amount:units.toQa(sendAmt,units.Units.Zil),
    gasPrice:units.toQa("20000",units.Units.Li),
    gasLimit:Long.fromNumber(1000),
  })
 // tx=await zilpay.blockchain.createTransaction(tx);
  console.log(tx.id);
 
}

async claimBack(){
 const deployedC='zil1jl6t04jlfrvrpjmthzlv7ts7cklzg7wesddy6t';//this.state.contractAddr;
 const user= await this.state.userAddress;
 console.log('userrrrrr....',this.state.userAddress)
  const deployedContract=await zilpay.contracts.at(deployedC);
  const claim = await deployedContract.call(
    'EndSoulzReaping',[],{
      tag:'EndSoulzReaping',
      version:VERSION,
      toAddr:deployedC,
      gasPrice:units.toQa("20000",units.Units.Li),
      gasLimit:Long.fromNumber(1000),
    }
  )
  console.log(claim.id)
}

async getBlockchainStats(){
  const blockchain = await window.zilPay.blockchain;
const blockNumber = await blockchain.getBlockChainInfo();
const block= await blockNumber.result.CurrentMiniEpoch;

this.setState({
  blockNumber:block
});
}

    render(){

        return(
<div>
         <br/><br/>
          <div>
              <center>
          <Card body inversse style={{maxWidth:'600px',backgroundColor:'#333',borderColor:'lime',color:'white',display:'flex'}}>
                <CardTitle>Table of Contents</CardTitle>
                <CardText>
                - KrazyKewlZil = KKZ - Govrernance/Voting/HODL<br/>
                KKZ Address: zil1p2cp77kz06wlxeyha4psawencm5gx8ttcwsxdn<br/>
                <br /> - Soulz = SOLZ - Used to Reap Demonz and more SOLZ as well as other LPairs added
                <br/>Soulz Address: zil1jl6t04jlfrvrpjmthzlv7ts7cklzg7wesddy6t<br/>

                <br />-Demonz = DMNZ - Used to Reap SOLZ as well as more DMNZ as well as other LPairs added<br />
                <br />- AnGilz = ANGL - Used to Reap SOLZ as well as more ANGL as well as other LPairs added<br />
                <br />-Reap/Reaping = Farming/Mining/Staking
                   <br />- Company Zilliqa Name is KrazyKewlZil<br />
                <br />-This project name is ZilzDemonz
                    </CardText>
              </Card>
              </center>
          </div>
          <br/><br/>
          <div>
              <center>
          <Card body inversse style={{maxWidth:'600px',backgroundColor:'#333',borderColor:'lime',color:'white',display:'flex'}}>
                <CardTitle>Reserved for KKZ Holders</CardTitle>
                <CardText>
                <img src={Soul}/><br/><br/>            
                </CardText>
                <CardBody>
                <form onSubmit={this.handleSubmitKkzDeposit}>
        <label>
          Min amount 1 KKZ: Released BlockNumber 932295<br/>
          <input type="text" value={this.state.kkzDeposit} onChange={this.handleKkzDepositChange} />
        </label><br/>
        <input disabled='true'  type="submit" value="Reap Your Soulz" />
      </form>
                </CardBody>
                  </Card>
              </center>
          </div>
          <br/><br/>
          <div>
<CardDeck>
  <Card body inverse style={{ backgroundColor: '#333', borderColor: 'red' }}>
    <CardHeader>Reap Soulz with Zil!</CardHeader>
    <CardBody>
      <CardText>
          <img src={Soul}/>
      </CardText>
      <CardText>
        Collect your Deposit<br/>
      </CardText>
      
      <form onSubmit={this.handleSubmitClaim}>
    <label>Soulz incoming</label><br/>
        <input  type="submit" value="Collect your Zil!" />
      </form>

      <br/>
    </CardBody>
  </Card>

  <Card body inverse style={{ backgroundColor: '#333', borderColor: 'red' }}>
<CardHeader>Soulz You are Collecting </CardHeader>
        <CardBody>
      <CardText>
        <br/>
        <br/>
        <img src={Eyes}/>
        <br/>
        
        <br/>Real-time update pending
        <br/>
        Current Block:<br/>
        {this.state.blockNumber}
        <br/><br/>
        <br/>
        Your Colleted Soulz:
        <p>{this.state.collectedSoulz}</p>

      </CardText>
    </CardBody>
  </Card>
  <Card body inverse style={{ backgroundColor: '#333', borderColor: 'red' }}> 
      <CardHeader>Your Demonz:<br/></CardHeader><br/>

    <CardBody>
      <CardText>
        <img src={Demon}/>
      </CardText>
      <CardText>
        Reap Your Demonz!!<br/>
        2 Weeks!
      </CardText>
      <form onSubmit={this.handleSubmitDemonZilDeposit}>
        <label>
          Min amount 1 Zill:<br/>
          <input type="text" value={this.state.demonZilDeposit} onChange={this.handleDemonZilDepositChange} />
        </label><br/>
        <input disabled='true' type="submit" value="Available BlockNumber pending..." />
      </form>
    </CardBody>
  </Card>
</CardDeck>
<br/>

</div>


</div>

         );
    
    }
}
